import withIndicador from "../../hoc/ControlCapacitaciones/withIndicador";
import Indicador from "../../view/components/Tablas/ControlCapacitaciones/ProcesosIntranet/ListaIndicadores/Indicador";

export default withIndicador(Indicador);